var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(-330.844 -156.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-search",
    "data-name": "Icon map-search",
    d: "M16.8,14.009A8.3,8.3,0,1,0,14.007,16.8l5.633,5.633,2.794-2.795Zm-7.079.84A5.122,5.122,0,1,1,14.848,9.73a5.13,5.13,0,0,1-5.124,5.119Z",
    transform: "translate(329.404 154.857)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.927011db51339ca8103b71fc7cb44eb6.svg";
export { ForwardRef as ReactComponent };